import { render, staticRenderFns } from "./filing.vue?vue&type=template&id=0beec3be"
import script from "./filing.vue?vue&type=script&lang=js"
export * from "./filing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports